import heliportImg from "../../../../images/contents/map/airfield/heliport.svg";
import heliportPaleImg from "../../../../images/contents/map/airfield/heliport_pale.svg";
import iconClose from "../../../../images/contents/map/pointinfo/close.svg";
import iconCloseActive from "../../../../images/contents/map/pointinfo/close_active.svg";
import iconCloseHover from "../../../../images/contents/map/pointinfo/close_hover.svg";

export const configHeliportDh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/heliport",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/heliport/%index%/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 4,
      "download_max": 32,
      "BoundingBox": {
        "West": 125.0,
        "South": 26.0,
        "East": 145.0,
        "North": 46.0
      }
    }
  }
};

export const configHeliportLayer = {
  "Name": "Heliport",
  "Renderer": "Heliport",
  "Attributes": {
    "min_zoom": 12,
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "type",
          "value": "MLIT"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 24,
            "height": 24,
            "offset_x": -12,
            "offset_y": -12,
            "url": heliportImg,
            "label_min_zoom": 14,
            "label_target": "heliport_name",
            "label_color": "rgb(76, 76, 76)",
            "font_size": 13
          },
          "dark": {
            "type": "image",
            "width": 24,
            "height": 24,
            "offset_x": -12,
            "offset_y": -12,
            "url": heliportPaleImg,
            "label_min_zoom": 14,
            "label_target": "heliport_name",
            "label_color": "rgb(192, 192, 192)",
            "font_size": 13
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "type",
          "value": "Custom"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 24,
            "height": 24,
            "offset_x": -12,
            "offset_y": -12,
            "url": heliportImg,
            "label_min_zoom": 14,
            "label_target": "name",
            "label_color": "rgb(76, 76, 76)",
            "font_size": 13
          },
          "dark": {
            "type": "image",
            "width": 24,
            "height": 24,
            "offset_x": -12,
            "offset_y": -12,
            "url": heliportPaleImg,
            "label_min_zoom": 14,
            "label_target": "name",
            "label_color": "rgb(192, 192, 192)",
            "font_size": 13
          }
        }
      }
    ],
    "key": "heliport_name",
    "close_button": iconClose,
    "close_button_hover": iconCloseHover,
    "close_button_active": iconCloseActive,
    "tooltip": {
      "font_size": 12,
      "text_color": "#fff",
      "line_color": "#fff",
      "line_width": 0.5,
      "fill_color": "rgba(0,0,0,0.9)",
      "width": 300,
      "padding": 4,
      "padding_top": 12,
      "padding_bottom": 12,
      "padding_left": 12,
      "padding_right": 12,
      "round_corner": 6,
      "text_lines": {
        "MLIT": [
          "%HELIPORT_TYPE%",
          "%heliport_name%",
          "%classification%",
          "%disaster_prevention_plan%",
          "%address%",
          "%administrator%",
          "%area%"
        ],
        "Custom": [
          "%HELIPORT_TYPE%",
          "%name%",
          "%LatLon%",
          "%memo%"
        ]
      }
    },
    "popup": {
      "font_size": 12,
      "text_color": "#222",
      "line_color": "#222",
      "line_width": 2,
      "fill_color": "rgba(250,250,250,0.9)",
      "title_fill_color": "rgba(103,93,139,0.7)",
      "title_text_color": "#FFFFFF",
      "width": 350,
      "padding": 4,
      "padding_top": 10,
      "padding_bottom": 10,
      "padding_left": 10,
      "padding_right": 10,
      "round_corner": 6,
      "text_lines": {
        "MLIT": [
          "%HELIPORT_TYPE%",
          "%heliport_name%",
          "%classification%",
          "%disaster_prevention_plan%",
          "%address%",
          "%administrator%",
          "%area%"
        ],
        "Custom": [
          "%HELIPORT_TYPE%",
          "%name%",
          "%LatLon%",
          "%memo%"
        ]
      }
    }
  }
};
